import { monteurApi } from '../common/monteur-api';
export var faqApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['PaginatedFaqs', 'Faq', 'DocumentFaqs']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        createFaq: builder.mutation({
            query: function (request) { return ({
                url: 'Faq/create',
                method: 'POST',
                body: request
            }); },
            invalidatesTags: ['PaginatedFaqs']
        }),
        updateFaq: builder.mutation({
            query: function (request) { return ({
                url: 'Faq/update',
                method: 'POST',
                body: request
            }); },
            invalidatesTags: ['PaginatedFaqs', 'Faq']
        }),
        getPaginatedFaqs: builder.query({
            query: function (query) { return ({
                url: 'Faq/get-paginated',
                method: 'POST',
                body: query
            }); },
            providesTags: ['PaginatedFaqs']
        }),
        getFaqById: builder.query({
            query: function (id) { return ({
                url: "Faq/get-by-id?id=".concat(id),
                method: 'GET'
            }); },
            providesTags: ['Faq']
        }),
        deleteFaq: builder.mutation({
            query: function (id) { return ({
                url: "Faq/delete?id=".concat(id),
                method: 'POST'
            }); },
            invalidatesTags: ['Faq', 'PaginatedFaqs']
        }),
        getFaqByMachine: builder.query({
            query: function (query) { return ({
                url: "Faq/get-by-machine",
                method: 'POST',
                body: query
            }); },
            providesTags: ['Faq']
        }),
        deleteMultipleFaqs: builder.mutation({
            query: function (ids) { return ({
                url: "Faq/delete-multiple",
                method: 'POST',
                body: ids
            }); },
            invalidatesTags: ['Faq', 'PaginatedFaqs']
        })
    }); }
});
export var useCreateFaqMutation = faqApi.useCreateFaqMutation, useUpdateFaqMutation = faqApi.useUpdateFaqMutation, useGetPaginatedFaqsQuery = faqApi.useGetPaginatedFaqsQuery, useLazyGetFaqByIdQuery = faqApi.useLazyGetFaqByIdQuery, useDeleteFaqMutation = faqApi.useDeleteFaqMutation, useGetFaqByMachineQuery = faqApi.useGetFaqByMachineQuery, useDeleteMultipleFaqsMutation = faqApi.useDeleteMultipleFaqsMutation;
